export default "__VITE_ASSET__C4NoT2Ow__"